import { getCustomerOptions, shouldShowCustomerSelector } from "../../../../../_metronic/helpers/UserRoleHelpers";

interface CustomerSelectorProps {
  selectedCustomer: string;
  user: any;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function CustomerSelector({
  selectedCustomer,
  user,
  onChange,
}: CustomerSelectorProps) {
  // Use new helper to check if user has multiple customers
  if (!user || !shouldShowCustomerSelector(user)) {
    return null;
  }

  const customerOptions = getCustomerOptions(user);

  return (
    <div className="d-flex align-items-center">
      <select
        className="form-select form-select-white h-50px"
        value={selectedCustomer}
        onChange={onChange}
      >
        {customerOptions.map((option, index) => {
          return (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
